import React, { useState } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { strings } from '/imports/strings';
import { Button } from '/imports/ui/Button';
import { Modal, ModalProps } from '/imports/ui/Modal';
import { Form } from '/imports/ui/Form';
import { toastOnError } from '/imports/ui/utils';
import { FormField } from '/imports/ui/FormField';
import { DateTimeInput } from '/imports/ui/DateTimeInput';
import { pullProductionIntervals } from '/imports/api/productionIntervals';

const PullProductionIntervalsModalStyled = styled(Modal)`
  .timezone {
    padding: 1rem 0;
  }
  .modal-title {
    font-size: 1.5rem;
  }
  .option-buttons {
    display: flex;
    justify-content: center;
    gap: 1rem;
  }
  input {
    display: inline-block;
    width: auto;
    margin-right: 1rem;
  }
`;

interface PullProductionIntervalsModalProps {
  meterIds: string[];
  onClose: ModalProps['onClose'];
}

/** Modal that pulls production intervals for the given meters over a chosen date range. */
export const PullProductionIntervalsModal = (props: PullProductionIntervalsModalProps) => {
  const meterIds = props.meterIds;
  const [from, setFrom] = useState<Date>();
  const [to, setTo] = useState<Date>();
  /** Validates the inputs, requests the interval pull, and toasts on success. */
  const submit = toastOnError(async () => {
    if (!meterIds?.length || !from || !to) return;
    await pullProductionIntervals.call({ meterIds, from, to });
    toast.success(strings.Running());
  });
  return (
    <PullProductionIntervalsModalStyled
      title={strings.PullProduction()}
      onClose={props.onClose}
    >
      <Form onSubmit={submit}>
        <div className="field-group">
          <FormField field="from">
            <label>{strings.From()}</label>
            <DateTimeInput id="pull-prod-from" value={from} onChange={(from) => setFrom(from)} step="900" />
          </FormField>
        </div>
        <div className="field-group">
          <FormField field="to">
            <label>{strings.To()}</label>
            <DateTimeInput id="pull-prod-to" value={to} onChange={(to) => setTo(to)} step="900" />
          </FormField>
        </div>
        <div className="buttons">
          <Button id="pull-prod-btn" type="submit" disabled={!meterIds[0] || !from || !to}>{strings.PullProduction()}</Button>
        </div>
      </Form>
    </PullProductionIntervalsModalStyled>
  );
};